import {
  BaseJsonSchema,
  createArraySchemaByItemType,
  createSchemaByBasicTypes,
} from "../../helpers";
import { AllBidderSchemas } from "../pre-mid-pos-rollConfig/Bidders/BidderSchemas";

export const IPrebid: BaseJsonSchema = {
  type: "object",
  properties: {
    nonUniversalServerBidders: createArraySchemaByItemType(undefined, [
      {
        type: "object",
        properties: {
          adapter: createSchemaByBasicTypes("string"),
          gvlid: createSchemaByBasicTypes("number"),
          prebidParams: createArraySchemaByItemType(
            undefined,
            AllBidderSchemas,
          ),
        },
      },
    ]),
    nonUniversalBidders: createArraySchemaByItemType(
      undefined,
      AllBidderSchemas,
    ),
    enabledBidders: {
      type: "object",
      properties: {
        "1accord": createSchemaByBasicTypes("boolean"),
        adagio: createSchemaByBasicTypes("boolean"),
        amx: createSchemaByBasicTypes("boolean"),
        appnexus: createSchemaByBasicTypes("boolean"),
        criteo: createSchemaByBasicTypes("boolean"),
        gumgum: createSchemaByBasicTypes("boolean"),
        ix: createSchemaByBasicTypes("boolean"),
        medianet: createSchemaByBasicTypes("boolean"),
        openx: createSchemaByBasicTypes("boolean"),
        pubmatic: createSchemaByBasicTypes("boolean"),
        rubicon: createSchemaByBasicTypes("boolean"),
        sharethrough: createSchemaByBasicTypes("boolean"),
        smartadserver: createSchemaByBasicTypes("boolean"),
        sovrn: createSchemaByBasicTypes("boolean"),
        triplelift: createSchemaByBasicTypes("boolean"),
        ttd: createSchemaByBasicTypes("boolean"),
        unruly: createSchemaByBasicTypes("boolean"),
      },
      required: [
        "1accord",
        "adagio",
        "amx",
        "appnexus",
        "criteo",
        "gumgum",
        "ix",
        "medianet",
        "openx",
        "pubmatic",
        "rubicon",
        "sharethrough",
        "smartadserver",
        "sovrn",
        "triplelift",
        "ttd",
        "unruly",
      ],
    },
    schainOverrides: {
      type: "object",
      properties: {
        publisher: {
          type: "object",
          properties: {
            bidders: createArraySchemaByItemType("string", [
              {
                type: "string",
                enum: [
                  "1accord",
                  "adagio",
                  "amx",
                  "appnexus",
                  "criteo",
                  "gumgum",
                  "ix",
                  "kargo",
                  "medianet",
                  "openx",
                  "pubmatic",
                  "rubicon",
                  "sharethrough",
                  "smartadserver",
                  "sovrn",
                  "triplelift",
                  "unruly",
                ],
              },
            ]),
            sid: createSchemaByBasicTypes("string"),
            asi: createSchemaByBasicTypes("string"),
          },
        },
        fabrik: {
          type: "object",
          properties: {
            sid: createSchemaByBasicTypes("string"),
          },
        },
      },
    },
  },
  additionalProperties: false,
};
